import { api } from "../http"
import type { OfficerProfile, OfficerProfileUpdateRequest } from "../types"

const buildPath = (officerId: string) => `/api/officers/${encodeURIComponent(officerId)}/profile`

export const officerProfileApi = {
  async get(officerId: string): Promise<OfficerProfile> {
    return api.get<OfficerProfile>(buildPath(officerId))
  },

  async update(officerId: string, payload: OfficerProfileUpdateRequest): Promise<OfficerProfile> {
    return api.put<OfficerProfile, OfficerProfileUpdateRequest>(buildPath(officerId), payload)
  },
}
